export enum EventType {
  wedding = 'wedding',
  general = 'general',
  babyRegistry = 'babyRegistry',
}

export type AllEventTypes = EventType | '';

export type EventData = {
  event: {
    fireBaseId: string;
    website: string;
    photo?: {
      url: string;
    };
    activeSession: {
      hasUnlocked: boolean;
      canAccessPage: boolean;
    };
    pageInfo: {
      disabled: boolean;
    };
    info: {
      eventType: EventType;
      ownerFullName: string;
      fianceeFullName?: string;
      // this date field can come back null.
      dateV0918?: {
        timestamp?: string;
      };
      // this date field can also come back null.
      tentativeDate?: {
        timestamp?: string;
      };
      finalizedDate?: {
        timestamp?: string;
      };
    };
  };
};
